<template>
  <div class="cmpn col">
    <b-card
      overlay
      img-src="../assets/home/screens-aragon-1.5-1280x594.jpg"
      img-alt="Header img"
      text-variant="white"
      title="Geekline - creativity &amp; innovation first!"
      sub-title="Passion to innovate!"
      style="text-align: center;">
      <!-- <b-card-text>Get started</b-card-text> -->
    </b-card>
    <b-card
      header-class="text-center"
      title="Geekline version"
      style="background-color: lightblue; margin: 2px;">
      <template v-slot:header>
        <i class="mdi mdi-contact-mail" style="font-size: 32px;"></i>
      </template>
      <p>
        glweb: {{ require('@/../package.json').version }}.{{ require('@/../package.json').build }}
      </p>
      <p>
        env: {{ this.prcEnv.NODE_ENV }}
      </p>
    </b-card>
  </div>
</template>
<script>
// const pageDescription = 'Responsive web design in html5, javascript. Python,java based REST or GraphQL Backend. Cloud and Big Data solutions. Online Marketing and SEO. SSL, STL, OAuth2.'
export default {
  name: 'version',
  data () {
    return {
      prcEnv: process.env
    }
  }, // data
  created () {
    this.$tracker('event', 'screen_view', {
      'app_name': 'geekline-web',
      'screen_name': 'Version'
    })
  },
  components: {
  }
}
</script>
<style>
.cmpn {
  margin-top: 85px;
}
</style>
